module.exports = __webpack_public_path__ + "24-o2.jpg?cfdffc34463386d8d39dd2d4a287b11e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/quiz/questions/24-o2.jpg
// module id = 649
// module chunks = 0